import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './assets/css/style.css'
import './assets/scss/index.scss'
import './components/Global'
import './plugins'
import './amplify'

Vue.config.productionTip = false

const app = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})

export default app
